import React, { useEffect, useState } from 'react';
import { MdArrowBackIos, MdAddAPhoto } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { createGroup } from '../../actions/groupActions';
import { ToastContainer } from 'react-toastify';
import { NEW_GROUP_RESET } from '../../constants/groupConstants';
import { BiHide, BiShow } from 'react-icons/bi';
import ReactGA from 'react-ga4';

const CreateGroup = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [grpasscode, setGrpasscode] = useState('');
    const [isPrivate, setIsPrivate] = useState(false);
    const [groupImage, setGrImage] = useState('');
    const [avatarPreview, setAvatarPreview] = useState(null);
    const [imageError, setImageError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [passcodeError, setPasscodeError] = useState(false);

    const { user } = useSelector(state => state.auth);
    const { createdGroup, loading } = useSelector(state => state.newGroup);
    const creator = user?._id;

    useEffect(() => {
        function handleResize() {
            if (window.innerWidth >= 768) { 
                navigate(`/groups`);
            }
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect (() => {
        if (createdGroup) {
            dispatch({ type: NEW_GROUP_RESET });
            // showToastMessage("Group created successfully!");
            setImageError(false);
            navigate(`/group/${createdGroup._id}`);
        }
    }, [createdGroup]);

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: (location.pathname + location.search), title: "Create Group" });
    }, [location]);

    const createGroupHandler = () => {
        const MAX_FILE_SIZE = 1024 * 1024 * 10;

        if(groupImage.size > MAX_FILE_SIZE){
            setImageError("Image size cannot exceed 10Mbs");
            return
        }
        if(isPrivate && !grpasscode){
            setPasscodeError("Please enter a password for your private group");
            return
        }
        dispatch(createGroup(creator, name, description, isPrivate, grpasscode, groupImage));
    };

    const onChange = e => {
        if(e.target.name === 'grimage') {
          const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    setAvatarPreview(reader.result)
                }
            }
            reader.readAsDataURL(e.target.files[0])
            setGrImage(e.target.files[0])
        } 
    }

  return (
    <div>
        <ToastContainer />
        <div className='h-[58px] flex justify-between items-center p-3 border-b border-gray-300'>
            <MdArrowBackIos onClick={() => navigate('/groups')} />
            <p className='createGroupLabel'>Create Group</p>
            <p className='inactiveDoneLabel'>Done</p>
        </div>
        <div className='px-4'>
            <div className="mb-4 pt-4">
                <label className=" createFormLabels block text-sm mb-2" htmlFor="group_name">
                    Group Name
                </label>
                <input value={name} onChange={(e) => setName(e.target.value)} className="border rounded w-full py-2 px-3" id="group_name" type="text" placeholder="Group Name" />
            </div>
            <div className="mb-4">
                <label className=" createFormLabels block text-sm mb-2" htmlFor="group_description">
                    Group Description
                </label>
                <textarea value={description} onChange={(e) => setDescription(e.target.value)} id="group_description" rows="3" className="mt-1 py-2 px-3 block w-full rounded border " placeholder="Group Description">
                </textarea>
            </div>
            
            <div className='flex flex-row justify-center items-center w-full mb-2'>
                <div className="flex justify-center items-center h-[130px] w-[130px] rounded-lg border-2 bg-gray-100 border-gray-100" style={{ 
                        backgroundImage: `url(${avatarPreview})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat'
                    }}>
                    <div className="absolute">
                        <div className="flex flex-col items-center">
                            <MdAddAPhoto className='w-9 h-9' />
                            <span className="block text-gray-400 font-normal">Add Photo</span>
                        </div>
                    </div>
                    <input type="file" name="grimage" onChange={onChange} className="h-full w-full opacity-0" />
                </div>
            </div>
            <div className='flex flex-col justify-center items-center w-full mb-4'>
                {imageError && <p className='text-sm text-red-600 max-w-[250px]'>{imageError}</p>}
                <p className='createinfotext max-w-[250px]'>You can change your group's name and photo at anytime</p>
            </div>
            <div className={`flex gap-4 w-full flex-col mb-4`}>
                <label className="createFormLabels block" htmlFor="group_type">
                    Group Type
                </label>
                <select className='border createFormInput h-[50px] px-4' value={isPrivate} onChange={(e) => setIsPrivate(e.target.value === 'true')}>
                    <option>Select</option>
                    <option value={false}>Public</option>
                    <option value={true}>Private</option>
                </select>
            </div>
            {isPrivate &&
            <div className={`mb-4 pb-4`}>
                <label className="createFormLabels block text-sm mb-2" htmlFor="group_passcode">
                    Group Passcode
                </label>
                <div className="relative w-full">
                    <input value={grpasscode} onChange={(e) => setGrpasscode(e.target.value)} className="border rounded w-full py-2 px-3" id="group_passcode" type={showPassword ? "text" : "password"} autoComplete="new-password" placeholder="Group Passcode" />
                    <div onClick={() => setShowPassword(!showPassword)} className="absolute top-1/2 right-3 -mt-2 text-gray-600">
                        {showPassword ?
                        <BiShow /> : <BiHide />}
                    </div>
                </div>
                {passcodeError && <p className='text-sm text-red-600'>{passcodeError}</p>}
            </div>}
            <div className="mb-4">
                <button className='w-full h-10 mb-3 bg-[#CBD2E0] rounded-[20px]' onClick={() => createGroupHandler()}>
                    {loading ?
                    <>
                    <svg role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                    </svg> Save </> : <>Save</>}
                </button>
                <Link to={'/groups'} className='flex justify-center items-center w-full h-10 border rounded-[20px]'>Cancel</Link>
            </div>
        </div>
    </div>
  )
}

export default CreateGroup